class Organization {
  id
  name

  static assign (json) {
    return Object.assign(new Organization(), json)
  }
}

export default Organization



// WEBPACK FOOTER //
// ./src/models/dictionaries/organization.js